import type { Tenant } from '@planet-sdk/common';

export const defaultTenant: Tenant = {
  id: 'ten_NxJq55pm',
  config: {
    appDomain: 'https://web.plant-for-the-planet.org/',
    externalUrl: 'https://web.plant-for-the-planet.org',
    customDomain: 'https://web.plant-for-the-planet.org',
    font: {
      primaryFontURL: null,
      secondaryFontURL: null,
      primaryFontFamily:
        '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      secondaryFontFamily:
        '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    },
    meta: {
      image:
        'https://cdn.plant-for-the-planet.org/media/images/app/bg_layer.jpg',
      title: 'Plant trees around the world - Plant-for-the-Planet',
      locale: 'en_US',
      appTitle: 'Plant for the Planet',
      description:
        "We are children and youth on a mission: bring back a trillion trees! No matter where you are, it's never been easier to plant trees and become part of the fight against climate crisis.",
      twitterHandle: '',
    },
    slug: 'planet',
    header: {
      items: [
        {
          link: '/',
          headerKey: 'home',
          visible: true,
          headerText: 'home',
        },

        {
          headerText: 'aboutUs',
          title: 'aboutUs',
          hasSection: true,
          menu: [
            {
              sectionKey: 'organization',
              title: 'organization',
              description: 'organizationDescription',
              items: [
                {
                  menuKey: 'organization',
                  title: 'organization',
                  link: 'https://www.plant-for-the-planet.org/about-us/',
                  visible: true,
                  onlyIcon: false,
                },
                {
                  menuKey: 'transparency',
                  title: 'transparency',
                  link: 'https://www.plant-for-the-planet.org/annual-reports/',
                  visible: true,
                  onlyIcon: false,
                },
                {
                  menuKey: 'partner',
                  title: 'partner',
                  link: 'https://www.plant-for-the-planet.org/partners/',
                  visible: true,
                  onlyIcon: false,
                },
              ],
            },
            {
              sectionKey: 'platform',
              title: 'platform',
              items: [
                {
                  menuKey: 'platform',
                  title: 'platform',
                  description: 'platformDescription',
                  link: '/all',
                  visible: true,
                  onlyIcon: false,
                },
                {
                  menuKey: 'redeemCode',
                  title: 'redeemCode',
                  description: 'redeemCodeDescription',
                  link: 'https://www.plant-for-the-planet.org/status/',
                  visible: true,
                  onlyIcon: false,
                },
                {
                  menuKey: 'support',
                  title: 'support',
                  description: 'supportDescription',
                  link: 'https://donate.plant-for-the-planet.org/?to=proj_bFH0BU0Qw02RuetpQlLOMVYX',
                  visible: true,
                  onlyIcon: false,
                },
              ],
            },
            {
              sectionKey: 'socialSites',
              items: [
                {
                  menuKey: 'instagram',
                  title: 'instagram',
                  link: 'https://www.instagram.com/plantfortheplanet_official/',
                  visible: true,
                  onlyIcon: true,
                },
                {
                  menuKey: 'facebook',
                  title: 'facebook',
                  link: 'https://www.facebook.com/plantfortheplanet',
                  visible: true,
                  onlyIcon: true,
                },
                {
                  menuKey: 'youtube',
                  title: 'youtube',
                  link: 'https://www.youtube.com/user/PlantForThePlanet',
                  visible: true,
                  onlyIcon: true,
                },
                {
                  menuKey: 'linkedin',
                  title: 'linkedin',
                  link: 'https://www.linkedin.com/company/plant-for-the-planet/',
                  visible: true,
                  onlyIcon: true,
                },
              ],
            },
          ],
          headerKey: 'about',
          visible: true,
        },
        {
          headerText: 'tools',
          title: 'tools',
          hasSection: false,
          menu: [
            {
              menuKey: 'treeMapper',
              title: 'treeMapper',
              link: 'https://www.plant-for-the-planet.org/treemapper/',
              description: 'treeMapperDescription',
              visible: true,
              onlyIcon: false,
            },
            {
              menuKey: 'fireAlert',
              title: 'fireAlert',
              link: 'https://www.plant-for-the-planet.org/firealert/',
              description: 'fireAlertDescription',
              visible: true,
              onlyIcon: false,
            },
            {
              menuKey: 'tracer',
              title: 'tracer',
              link: 'https://www.plant-for-the-planet.org/tracer/',
              description: 'tracerDescription',
              visible: true,
              onlyIcon: false,
            },
            {
              menuKey: 'restorationAdvice',
              title: 'restorationAdvice',
              link: 'https://www.plant-for-the-planet.org/advice/',
              description: 'restorationAdviceDescription',
              visible: true,
              onlyIcon: false,
            },
            {
              menuKey: 'restorationStandards',
              title: 'restorationStandards',
              link: 'https://www.plant-for-the-planet.org/standards/',
              description: 'restorationStandardsDescription',
              visible: true,
              onlyIcon: false,
            },
          ],
          visible: true,
          headerKey: 'tools',
        },
        {
          link: '/all',
          visible: false,
          headerKey: 'leaderboard',
          headerText: 'leaderboard',
        },
        {
          headerText: 'signIn',
          link: '/me',
          visible: true,
          headerKey: 'me',
          loggedInHeaderText: 'me',
        },
      ],
      tenantLogoURL: 'https://cdn.plant-for-the-planet.org/logo/svg/planet.svg',
      tenantLogoLink: '/',
      isSecondaryTenant: false,
    },
    manifest: '/tenants/planet/manifest.json',
    languages: ['en', 'de', 'es', 'fr', 'it', 'pt-BR', 'cs'],
    tenantURL: 'web.plant-for-the-planet.org',
    tenantGoal: null,
    footerLinks: [
      'shop',
      'privacy',
      'terms',
      'imprint',
      'contact',
      'downloads',
      'annualReports',
      'team',
      'jobs',
      'supportUs',
      'blogs',
      'faqs',
    ],
    showUNEPLogo: true,
    showRedeemHint: true,
    darkModeEnabled: false,
    enableGuestSepa: false,
    fallbackCurrency: null,
    showUNDecadeLogo: true,
  },
  images: { featuredImage: null, bannerImage: null },
  name: 'Plant-for-the-Planet',
  description:
    'This Tenant is used for Beta version of the  Plant-for-the-Planet Web App. At the end of the beta period, all donations will be re-associated to the main Plant-for-the-Planet Tenant',
  topProjectsOnly: false,
  image: null,
  tenantGoal: 2147483647,
};
